module.exports = __webpack_public_path__ + "img/member-8.71dcbbc8.png";